

export const sellers = [
	   
	// #FLIXBUS
	{
		id: 39,
		modes: ["bus"],
		
		countries: [
			['AL', 'AD', 'AT', 'BE', 'BA', 'BG', 'HR', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IT', 'LV', 'LI', 'LT', 'LU', 'MK', 'MT', 'MD', 'MC', 'ME', 'NL', 'NO', 'PL', 'PT', 'RO', 'SM', 'RS', 'SK', 'SI', 'ES', 'SE', 'CH', 'TR', 'GB', 'UA'], //europe
			['US', 'CA', 'MX'], //north-america
			['BR'], //brasil
			['CL'], //chile
			['IN'], //india
        ]
	},
	
	// #DISTRIBUSION
	{
		id: 41,
		modes: ["bus", "train"],
		
		countries: [
			['FR', 'IT', 'ES', 'DE', 'NL', 'BE', 'LU'], //europe
			['GB'], //uk
			['PT'], //portugal
			['HR', 'BA', 'RS', 'ME', 'MK', 'AL'], //balkan
        ]
	},
	

	// #12GO
	{
		id: 66,
		modes: ["bus", "train"],
		countries: [
		['GR'], 
		['UA'], 
		['CZ'],
		['RO'],
		['TW'],
		['JP'],
		['KR'],
		['CN', 'HK'], //china
		['IN', 'BD', 'NP'], //india
		['LK'], //SRI LANKA
		['TH', 'KH', 'VN', 'MY', 'SG', 'ID', 'LA'], //southeast asia
		['PH'],
		['MA'],
		['EG'],
		['NZ'],
		['AU'],
		['KZ', 'UZ'], //central asia
        ]
	},
	


	// #BLABLACAR
	{
		id: 37,
		modes: ["carpool"],
		distance: {
		max: 1200,
		},
	  
		countries: [
            ['FR', 'DE', 'BE', 'NL', 'LU', 'CH', 'ES', 'IT', 'PT'], //west europe
			['IN'], //india
			['TR'], //turkey
			['BR'], //brasil
    ]
	},
	

	// #SNCF
	{
	  id: 2,
	  modes: ["train"],
	  
		countries: [
		['FR', 'BE'],
        ],
	},
	

	// #TRENITALIA
	{
	  id: 68,
	  modes: ["train"],
	  
		countries: [
			['IT'],
        ],
	},
	

	// #BUSBUD
	{
	  id: 59,
	  modes: ["bus"],
	  
		countries: [
			['US', 'CA', 'MX'], //north-america
			['IT', 'PT', 'ES', 'FR', 'DE', 'IT'], //europe
			['IE', 'GB'], //british-isles
			['EE', 'LV', 'LT', 'PL', 'UA', 'SK'], //baltic
            ['NO','SE'], //nordic
			['BG', 'TR', 'GR', 'AL'], //bulgaria-turkey
			['ZA'], //africa-south
			['BR', 'PE', 'CL', 'AR', 'CO'], //america-south
			['MX', 'BZ', 'CR', 'GT', 'HN', 'NI', 'PA', 'SV'], //central-america
			['AU'], //australia
			['HR', 'BA', 'RS', 'ME', 'MK'], //balkan
        ]
	}


]